module.exports = __webpack_public_path__ + "media/poll.eb2756ff.webm";